import * as React from 'react'

import type {
  ContractDetailContractVersionRequestFragment,
  ContractVersionPageContractVersionFragment,
  ContractVersionsPageEmployeeFragment,
} from 'generated/resources/graphql'

import FlowSelectorModal from 'modules/contracts/components/FlowSelectorModal'
import PendingApprovalModal from 'modules/contracts/components/PendingApprovalModal'

interface Props {
  employee: ContractVersionsPageEmployeeFragment
  onCloseModal: () => void
  selectedContractVersion: ContractVersionPageContractVersionFragment
  allContractVersions: ContractVersionPageContractVersionFragment[]
  setOption: React.Dispatch<React.SetStateAction<string>>
  option: string
  showFixOption?: boolean
  contractVersionRequest?: ContractDetailContractVersionRequestFragment
  canPromote: boolean
  hasToRequestUpdate: boolean
}

const ModalSelector = ({
  employee,
  onCloseModal,
  selectedContractVersion,
  allContractVersions,
  setOption,
  option,
  showFixOption,
  contractVersionRequest,
  canPromote,
  hasToRequestUpdate,
}: Props) => {
  if (contractVersionRequest) {
    return (
      <PendingApprovalModal
        onCloseModal={onCloseModal}
        contractVersionRequest={contractVersionRequest}
        canPromote={canPromote}
      />
    )
  }

  return (
    <FlowSelectorModal
      employee={employee}
      onCloseModal={onCloseModal}
      selectedContractVersion={selectedContractVersion}
      allContractVersions={allContractVersions}
      setOption={setOption}
      option={option}
      showFixOption={showFixOption}
      hasToRequestUpdate={hasToRequestUpdate}
    />
  )
}

export default ModalSelector
